export const getAPIUrl = () => {
  if (window.location.host.startsWith("localhost")) {
    return 'http://localhost:4000';
  } else {
    return 'https://monitor-api.remotexs.co';
  }
};
export const title = "RemoteXS Monitor";

